import React from 'react';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { logAmplitudeEvent } from 'src/utils/analytics';

interface CustomTooltipProps extends TooltipProps {
  tooltipType?: string;
  parent?: string;
}

const InfoTooltip = styled(
  ({ className, tooltipType, parent, onOpen, onClose, ...props }: CustomTooltipProps) => (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      onOpen={e => {
        logAmplitudeEvent('tooltip_interacted', {
          tooltip_type: tooltipType || '',
          parent: parent || '',
        });
        if (onOpen) onOpen(e);
      }}
      onClose={e => {
        if (onClose) onClose(e);
      }}
    />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: 0,
    width: 400,
  },
}));

export default InfoTooltip;
